import { render, staticRenderFns } from "./TheSideBarResourceInfo.vue?vue&type=template&id=05513d36&"
import script from "./TheSideBarResourceInfo.vue?vue&type=script&lang=js&"
export * from "./TheSideBarResourceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports